import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

const isDev = import.meta.env.DEV
const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
const isProdHost =
  hostname.endsWith('dextoro.com') || hostname.endsWith('.pages.dev')

let resolvedUrl = supabaseUrl
let resolvedKey = supabaseAnonKey

if (!supabaseUrl || !supabaseAnonKey) {
  if (isDev && !isProdHost) {
    console.warn(
      '[supabase] VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY not configured, queries will fail in dev. Set them in .env.local to enable.'
    )
    resolvedUrl = supabaseUrl || 'https://stub.invalid.supabase.co'
    resolvedKey = supabaseAnonKey || 'stub'
  } else {
    throw new Error('Supabase environment variables are required in production')
  }
}

// Using 'any' for database type until tables are created
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const supabase = createClient<any>(resolvedUrl, resolvedKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
})

// Supabase throws PostgrestError, a plain object with `.message`/`.code`/`.hint`,
// not an Error instance. `instanceof Error` checks fall through to generic
// fallbacks ("Mutation failed", "Failed to remove user") and lose all context.
export function toError(e: unknown, fallback: string): Error {
  if (e instanceof Error) return e
  if (e && typeof e === 'object') {
    const obj = e as { message?: unknown; code?: unknown; hint?: unknown; details?: unknown }
    if (typeof obj.message === 'string' && obj.message.length > 0) {
      const err = new Error(obj.message)
      if (typeof obj.code === 'string') (err as Error & { code?: string }).code = obj.code
      return err
    }
  }
  return new Error(fallback)
}
